import { render, staticRenderFns } from "./ModDashboardAttendeesTab.vue?vue&type=template&id=6c60356c&"
import script from "./ModDashboardAttendeesTab.vue?vue&type=script&lang=js&"
export * from "./ModDashboardAttendeesTab.vue?vue&type=script&lang=js&"
import style0 from "./ModDashboardAttendeesTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VDivider,VProgressCircular,VTextField})
